import type { WaterLevelChartApiResponse } from '@/types/site';
import { XHRAuthorizedClient } from '../client';
import { ENDPOINTS } from '../endpoints';

export type WaterLevelPeriod = 'daily' | 'weekly' | 'monthly';

export const fetchWaterLevelChart = async (
  siteId: string,
  period: WaterLevelPeriod,
  selectedDate: string | undefined = undefined
) => {
  const response = await XHRAuthorizedClient.get<WaterLevelChartApiResponse>(
    ENDPOINTS.dashboard.waterLevelChart(siteId, period),
    {
      params: {
        date: selectedDate,
      },
    }
  );

  return response.data.data;
};
